import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { User } from "@modules/users/types";

export const usePrescriberListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  promocodeModalRef: RefObject<ModalRef>,
  users?: User[],
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("prescriber_admin.fields.id"),
        width: 80,
      },
      {
        field: "user",
        headerName: translate("prescriber_admin.fields.user"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/users/edit/${value}`}
            value={users?.find(user => user.id === value)?.full_name}
          />
        ),
      },
      {
        field: "board_code",
        headerName: translate("prescriber_admin.fields.board_code"),
        minWidth: 150,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "board_number",
        headerName: translate("prescriber_admin.fields.board_number"),
        minWidth: 200,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "board_state",
        headerName: translate("prescriber_admin.fields.board_state"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            align="center"
          />
        ),
      },
      {
        field: "created_at",
        headerName: translate("prescriber_admin.fields.created_at"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Date value={value} align="center" />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => promocodeModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, promocodeModalRef, users],
  );
};
